// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2ObyC","alertIcon":"ConfirmModal_alertIcon__2-t3k"};